import { useEffect, useState } from 'react';

import type Paginated from 'app/core/paginable';
import { useGetApplication } from 'app/hooks';

import { type EnvironmentVariable } from '../models/environmentVariable.model';
import environmentService from '../services/environment.service';

function useEnvironment(system: string, id: string) {
  const [data, setData] = useState<Paginated<EnvironmentVariable>>({
    currentPage: 0,
    firstRowOnPage: 0,
    lastRowOnPage: 0,
    pageCount: 0,
    pageSize: 0,
    rowCount: 0,
    data: []
  });

  useEffect(() => {
    // se debe recuperar el elemtno que esta para editarse
    const getEnvironments = async () => {
      const response = await environmentService.list(system, 1, 1, { id });
      setData(response);
    };
    getEnvironments();
  }, [system, id]);

  const { data: d = [] } = data;
  const [environment] = d;

  return { loading: !environment, environment };
}

export function useApplicationEnvironmentByName(name: string) {
  const [{ data, loading }] = useGetApplication<Paginated<EnvironmentVariable>>({
    url: '/environment',
    params: {
      page: 1,
      pageSize: 1,
      name
    }
  });

  const newData = data?.data || [];
  const [environment] = newData;

  return { loading: loading, environment };
}

export const getApplicationEnvironmentByName = async (
  name: string
): Promise<EnvironmentVariable> => {
  const response = await environmentService.list('application', 1, 1, { name });
  const { data: d = [] } = response;
  const [environment] = d;

  return environment;
};

export default useEnvironment;
